<template>
  <div class="content background">
    <div class="pageTitle"><p>{{ $t('label_753') }}</p></div>
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table">
          <div class="selectBox">
            <div class="selectChoose">
              <div class="selectText" style="width: 150px;">
                <p>{{ $t('label_343') }}</p>
              </div>
              <div>
                <el-input v-model="selectDataList.name"></el-input>
              </div>
            </div>
            <div>
              <div class="buttonBox" style="position: absolute; right: 0; bottom: 8px;">
                <div>
                  <div class="chooseButton sendButton" @click="selectParamList"><i
                    class="el-icon-search"></i>{{ $t('btn_2') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btnBox2">
            <div class="editButton" @click="update2" v-if="MenuRoleList.indexOf('306')>=0"><i class="el-icon-edit"></i>{{ $t('btn_15') }}
            </div>
          </div>
          <el-table
            :empty-text="$t('label_357')"
            :data="tableData2"
            highlight-current-row
            @current-change="handleCurrentChange2"
            border
            style="width: 100%;"
            height="88%"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                             :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('label_343')" align="center">
            </el-table-column>
            <el-table-column
              prop="value" align="center"
              :label="$t('label_764')">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_15')"
      :visible.sync="unUpdateVisible2" append-to-body
      :close-on-click-modal='false'
      width="40%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 350px; margin: 0 auto;">
        <div class="dialogMes">
          <div>
            <p style="width: 130px;">{{ $t('label_343') }}</p>
          </div>
          <div class="mesInput">
            <el-input v-model="dictDataList.name" style="width: 220px;"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <div>
            <p style="width: 130px;"><span style="color: #ff0000;margin-top: 10px;">*</span>{{ $t('label_764') }}</p>
          </div>
          <template v-if="dictDataList.type == '1'">
            <div class="mesInput">
              <el-input v-model="dictDataList.value" style="width: 220px;"></el-input>
            </div>
          </template>
          <template v-if="dictDataList.type == '2'">
            <div class="mesInput" style="width: 100%;">
              <el-date-picker v-model="dictDataList.value" value-format="yyyy-MM-dd" type="date"></el-date-picker>
            </div>
          </template>
        </div>
        <div class="dialogMes">
          <div class="mesInput" style="width: 100%; text-align: center;">
            <el-radio v-model="dictDataList.type" label="1">{{ $t('label_141') }}</el-radio>
            <el-radio v-model="dictDataList.type" label="2">{{ $t('label_70') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unUpdateSend2"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import DictPage from "@/assets/js/dictPage/dictPage.js";
import utils from '@/utils/utils'

export default {
  name: 'dictPage',
  components: {
    Page
  },
  data() {
    return {
      saveLoading: false,
      model: [],
      MenuRoleList: [],
      unDetailList: [],
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      unUpdateVisible2: false,
      dictDataList: {
        id: '',
        value: '',
        name: '',
        type: ''
      },
      selectDataList: {
        name: ''
      },
      tableData2: [],
      tableInfo1: {},
      tableInfo2: {},
      tableInfo3: {}
    }
  },
  methods: {
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    update2() {
      if (this.tableInfo2 != null && Object.keys(this.tableInfo2).length > 0) {
        this.unUpdateVisible2 = true;
        this.dictDataList.id = this.tableInfo2.id;
        this.dictDataList.name = this.tableInfo2.name;
        this.dictDataList.value = this.tableInfo2.value;
        this.dictDataList.type = this.tableInfo2.type;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    handleClose() {
      this.unDetailList = [];
      this.unUpdateVisible2 = false;
    },
    selectParamList() {
      DictPage.selectParamList1(this.selectDataList.name).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData2 = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    unUpdateSend2() {
      this.saveLoading = true;
      if (utils.isEmpty(this.dictDataList.value)) {
        this.$message.error(this.$t('msg_89'));
        this.saveLoading = false;
        return false;
      }
      DictPage.updateParam(this.dictDataList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unUpdateVisible2 = false;
          this.selectParamList();
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    handleCurrentChange2(info) {
      this.tableInfo2 = info;
    },
  },
  created() {
    this.selectParamList();
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/basic/paramPage.vue